export const LOADLOCALITIES_START = 'react/localities/LOADLOCALITIES_START';
export const LOADLOCALITIES_COMPLETE = 'react/localities/LOADLOCALITIES_COMPLETE';
export const LOADLOCALITIES_ERROR = 'react/localities/LOADLOCALITIES_ERROR';
export const CHANGELOCALITIES = 'react/localities/CHANGELOCALITIES';
export const ADDLOCALITIES = 'react/localities/ADDLOCALITIES';
export const LOCALITIES_DESTROY = 'react/localities/LOCALITIES_DESTROY';
export const CREATE_LOCALITY = 'react/localities/CREATE_LOCALITY';

const initialState = {
  list: [],
  created: [],
  value: '',
  loading: false
};

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case LOADLOCALITIES_COMPLETE: {
      const created = [...state.created];
      if (!action.result) {
        return {
          ...state,
          list: [...created],
          loading: false
        };
      }
      return {
        ...state,
        list: [...action.result.localities, ...created],
        loading: false
      };
    }
    case LOADLOCALITIES_START:
      return {
        ...state,
        loading: true
      };
    case LOADLOCALITIES_ERROR:
      return {
        ...state,
        loading: false
      };
    case CHANGELOCALITIES:
      return {
        ...state,
        value: action.data
      };
    case ADDLOCALITIES: {
      const created = state.created.filter(x => x.cityId === action.cityId);
      try {
        return {
          ...state,
          list: [...action.data, ...created] || []
        };
      } catch (err) {
        return {
          ...state,
          list: [...created],
        };
      }
    }
    case CREATE_LOCALITY:
      return {
        ...state,
        list: [...state.list, action.data],
        created: [...state.created, action.data],
        value: action.data
      };
    case LOCALITIES_DESTROY:
      return {
        ...state,
        list: [],
        value: '',
        loading: false
      };
    default:
      return state;
  }
}

export function loadLocalities(data) {
  return {
    types: [LOADLOCALITIES_START, LOADLOCALITIES_COMPLETE, LOADLOCALITIES_ERROR],
    promise: (client) => client.get('/api/address/areas/' + data)
  };
}

export function createLocality(data) {
  return {
    type: CREATE_LOCALITY,
    data
  };
}

export function changeLocalities(data) {
  return {
    type: CHANGELOCALITIES,
    data
  };
}

export function addLocalities(data, cityId) {
  console.log('>>>>', data);
  console.log('>>>>', cityId);
  return {
    type: ADDLOCALITIES,
    data,
    cityId
  };
}

export function destroyLocalities() {
  return { type: LOCALITIES_DESTROY };
}



// WEBPACK FOOTER //
// ./Scripts/redux/modules/addressForm/localities.js